/** Clinical authentication comes from the staff session, never a share URL. */
export function updateAuthServiceAndCleanUrl(): void {
  const url = new URL(window.location.href);
  if (url.searchParams.has('token')) {
    url.searchParams.delete('token');
    window.history.replaceState(null, '', url);
  }
}
